"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
class HttpError extends Error {
    statusCode;
    fetchUrl;
    fetchInit;
    constructor(code, message, extras) {
        super(message);
        this.name = 'HttpError';
        this.statusCode = code;
        if (extras?.cause)
            this.cause = extras.cause;
        if (extras?.stack)
            this.stack = extras.stack;
        if (extras?.fetchUrl)
            this.fetchUrl = extras.fetchUrl;
        if (extras?.fetchInit)
            this.fetchInit = extras.fetchInit;
    }
}
exports.HttpError = HttpError;
//# sourceMappingURL=http-error.js.map